// src/components/Our_Team/Our_Team.js

import React, { useEffect, useState } from 'react';
import axios from '../api/axios'; 
import './Our_Team.css';

const OurTeam = () => {
  const [years, setYears] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = 'https://blog.dietchapter.hosting.acm.org/'; 

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/ourteam');
      setYears(res.data);
      
      if (res.data.length > 0) {
        setSelectedYearId(res.data[0].id); 
      }
    } catch (err) {
      console.error('Failed to fetch team:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinNow = async () => {
    try {
      const res = await axios.get('/join-link'); 
      const data = res.data;
      if (data?.link) window.open(data.link, "_blank");
      else alert("Join link not found.");
    } catch (err) {
      console.error("Error fetching join link:", err);
      alert("Unable to open the join link right now.");
    }
  };
  
  const selectedYear = years.find((year) => year.id === selectedYearId);

  const formatPath = (path) => {
    return `${BASE_URL}/${path.replace(/\\/g, '/')}`;
  };

  if (loading) {
    return <div className="our-team-container loading-page">Loading team history...</div>;
  }
  
  return (
    <section id="ourteam" className="our-team-container">
      <h2 className="our-team-title">TEAM MEMBERS</h2>
      <p className="our-team-subtitle">
        Meet the brilliant minds behind the DIET ACM Student Chapter, year after year. 
        Our dedicated team works tirelessly to foster innovation and build a thriving tech community.
      </p>

      {/* Year Selector Buttons (Sorted newest-first by backend) */}
      <div className="year-buttons">
        {years.map(year => (
          <button
            key={year.id}
            onClick={() => setSelectedYearId(year.id)}
            className={`year-button ${selectedYearId === year.id ? 'active' : ''}`}
          >
            {year.label}
          </button>
        ))}
      </div>

      {selectedYear && (
        <div>
          {/* 1. INSTITUTE COORDINATORS */}
          <h3 className="section-title">INSTITUTE COORDINATORS</h3>
          {/* Add a specific grid class for layout control */}
          <div className="team-grid coordinators-grid coordinator-layout"> 
            {selectedYear.InstituteCoordinators?.map(member => (
              <div className="member-card coordinator-card-design" key={member.id}>
                {/* Image is circular in design, kept generic class */}
                <img src={formatPath(member.imagePath)} alt={member.name} className="member-image" /> 
                <div className="member-info">
                  <p className="member-name coordinator-name-style"><strong>{member.name}</strong></p>
                  <p className="member-title coordinator-title-style">{member.title}</p>
                </div>
              </div>
            ))}
            {selectedYear.InstituteCoordinators?.length === 0 && (
                <p className="no-members-msg">No institute coordinators listed for {selectedYear.label}.</p>
            )}
          </div>
          
          {/* 2. EXECUTIVE COMMITTEE MEMBERS */}
          <h3 className="section-title executive-title">EXECUTIVE COMMITTEE MEMBERS</h3>
          {/* Add a specific grid class for layout control */}
          <div className="team-grid executive-grid executive-layout"> 
            {selectedYear.ExecutiveCommitteeMembers?.map(member => (
              <div className="member-card executive-card-design" key={member.id}>
                {/* Image is rectangular/square in design, but must use a specific class */}
                <img src={formatPath(member.imagePath)} alt={member.name} className="member-image executive-image" />
                <div className="member-info">
                    <p className="member-name executive-name-style"><strong>{member.name}</strong></p>
                    <p className="member-title executive-title-style">{member.title}</p>
                </div>
              </div>
            ))}
            {selectedYear.ExecutiveCommitteeMembers?.length === 0 && (
                <p className="no-members-msg">No executive members listed for {selectedYear.label}.</p>
            )}
          </div>
        </div>
      )}

      {/* Join Our Team Section (Unchanged) */}
      <div className="join-team-section">
        <h3 className="join-team-title">Join Our Team</h3>
        <p className="join-team-text">
          Interested in becoming part of the DIET ACM Student Chapter? We're always looking for passionate 
          individuals who want to contribute to our tech community and make a difference.
        </p>
        <div className="join-team-buttons">
          <button className="apply-now-btn" onClick={handleJoinNow}>
            <i className="fas fa-magic"></i> Apply Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;